import * as actionTypes from 'actions';
import moment from 'moment'
/*user: {
  first_name: 'Shen',
  last_name: 'Zhi',
  email: 'demo@devias.io',
  avatar: '/images/avatars/avatar_11.png',
  bio: 'Brain Director',
  role: ['BASIC','GUEST', 'USER', 'ADMIN']
}*/
var t={}
try{
   t=  JSON.parse(localStorage.atom) 
}catch(e){ 
  t =  
   JSON.parse('{"user":{}}')
  };
const b ={
  name:"" ,
  avatar:  '/images/avatars/avatar_11.png',
  bio:  'guest',
  role:  ["GUEST"],
  expireTime:0,
  refreshExpireTime:0,
};
const userData = Object.assign({},b ,t)
const initialState = {
  loggedIn: false,
  user:userData
};

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SESSION_LOGIN: { 
    console.log(action)
      return Object.assign({},state,{user:action.user}) 
    }

    case actionTypes.SESSION_LOGOUT: {
      console.log(action);
      return  Object.assign({},state,{user:b}) 
    }

    default: { 
      return state;
    }
  }
};

export default sessionReducer;
